import { createContext, useContext } from 'react';

/**
 * ¿Este árbol de React está dentro de la app mobile (`PwaApp`)? Lo provee `PwaApp`; fuera de ella vale `false`.
 *
 * Existe para que las pantallas que se COMPARTEN con la plataforma web (hoy Comunidad) puedan ocultar lo que en
 * mobile no existe — el link a Home, "Bloquear mi agenda", el panel de admin — sin duplicar el componente.
 * Se usa un contexto y no `isPwaMode()` a propósito: `isPwaMode()` mira la URL/el dispositivo y puede no coincidir
 * con lo que está montado (ej. `/pwa` abierto desde un navegador de celular dentro de la web).
 */
const PwaModeContext = createContext(false);

export const PwaModeProvider = PwaModeContext.Provider;

export function useIsPwaApp(): boolean {
  return useContext(PwaModeContext);
}
